import './childObjects.tpl.html';

angular
  .module('shared.childObjects', [])
  .directive('sbsfChildObjects', directive)
  .controller('ChildObjectsCtrl', ['$scope', '$state', controller]);

/**
 * Directive to render object's child records
 *
 * @param {object} RecursionHelper
 * @return {object}
 */
function directive(RecursionHelper) {
  return {
    controller: 'ChildObjectsCtrl',
    templateUrl: 'shared/childObjects/childObjects.tpl.html',
    restrict: 'E',
    scope: {
      records: '=',
      selected: '=',
      parent: '=',
      isChildRecords: '=',
      onLink: '&'
    },
    compile: function (element) {
      return RecursionHelper.compile(element, function (scope) {
        scope.onLink();
      });
    }
  };
}

/**
 * ChildObjects directive controller
 *
 * @param {object} $scope
 * @param {object} $state
 */
function controller($scope, $state) {
  $scope.bulkRestoreData = $state.params.bulkRestoreData;

  const showChildrenMap = {};
  const ITEMS_PER_PAGE = 10;
  $scope.TABS = {
    MASTER: 'MASTER',
    LOOKUP: 'LOOKUP'
  };

  $scope.model = {
    sobjectNameList: [],
    currentTab: $scope.TABS.MASTER,
    masterDetailRelationships: false,
    lookupRelationships: false,
    lookupRelationshipsSwitchOn: false,
    isAllRecordsSelected: false
  };
  $scope.recordsGroupBySobjectName = {};
  $scope.pagingInfo = {
    itemsPerPage: ITEMS_PER_PAGE,
    currentPage: 1
  };

  $scope.isShowChildren = function (index) {
    return !!showChildrenMap[index];
  };

  $scope.showOrHideChildren = function (index, event) {
    event.preventDefault();
    event.stopPropagation();

    showChildrenMap[index] = !$scope.isShowChildren(index);
  };

  $scope.toggleGroupRecords = function (key) {
    const isGroupSelected = $scope.isGroupSelected(key);
    $scope.records.forEach((record) => {
      if (record.sobjectName === key) {
        record.isSelected = !isGroupSelected;
        if (!record.isSelected) {
          record.includeChildren = false;
          record.lookupRelationship = false;
          $scope.uncheckChildrenRecords(record.children);
        }
      }
    });
    $scope.toggleParentCheckbox();
  };

  $scope.toggleGroupChildren = function (key) {
    const isGroupChildrenIncluded = $scope.isGroupChildrenSelected(key);
    $scope.records.forEach((record) => {
      if (record.sobjectName === key) {
        record.includeChildren = !isGroupChildrenIncluded;
        if (record.includeChildren) {
          record.isSelected = true;
        } else {
          $scope.uncheckIncludeChildren(record.children);
        }
      }
    });
    $scope.toggleParentCheckbox();
  };

  $scope.isGroupSelected = function (key) {
    return $scope.records.some((record) => record.sobjectName === key && record.isSelected);
  };

  $scope.isGroupChildrenSelected = function (key) {
    return $scope.records.some((record) => record.sobjectName === key && record.isSelected && record.includeChildren);
  };

  $scope.isGroupLookupSelected = function (key) {
    return $scope.records.some(
      (record) => record.sobjectName === key && record.isSelected && record.lookupRelationship
    );
  };

  $scope.isAllGroupRecordsSelected = function () {
    return $scope.model.sobjectNameList.every((group) => {
      return $scope.isGroupSelected(group);
    });
  };

  $scope.isAllGroupChildRecordsIncluded = function () {
    return $scope.model.sobjectNameList.every((group) => {
      return $scope.isGroupChildrenSelected(group);
    });
  };

  $scope.isAllGroupLookupSelected = function () {
    return $scope.model.sobjectNameList.every((group) => {
      return $scope.isGroupLookupSelected(group);
    });
  };

  $scope.isAllRecordsSelected = function () {
    return $scope.records.every((record) => record.isSelected);
  };

  $scope.isSomeRecordsSelected = function () {
    return $scope.records.some((record) => record.isSelected);
  };

  $scope.onSelectAllCheckboxClick = function () {
    const isAllChildRecordsSelected = !$scope.isAllRecordsSelected();
    $scope.records.forEach((record) => {
      record.isSelected = isAllChildRecordsSelected;
    });
    if (!isAllChildRecordsSelected) {
      $scope.records.forEach((record) => {
        record.includeChildren = false;
        record.lookupRelationship = false;
        $scope.uncheckChildrenRecords(record.children);
      });
    }
    $scope.toggleParentCheckbox();
  };

  $scope.selectRecord = function (record) {
    record.isSelected = !record.isSelected;
    if (!record.isSelected) {
      record.includeChildren = false;
      record.lookupRelationship = false;
      $scope.uncheckChildrenRecords(record.children);
    }
    $scope.toggleParentCheckbox();
  };

  $scope.toggleParentCheckbox = function () {
    $scope.$emit('toggleRestoreObjectCheckboxes');
    const ignoreSelectingAllFlag = true;
    if (!$scope.bulkRestoreData.isObjectRecordSelected($scope.parent, ignoreSelectingAllFlag)) {
      $scope.bulkRestoreData.toggleObjectRecordSelection($scope.parent, ignoreSelectingAllFlag);
    }
  };

  $scope.$on('toggleRestoreObjectCheckboxes', () => {
    if (angular.isArray($scope.records)) {
      $scope.records.forEach((record) => {
        if (!record.isSelected) {
          record.isSelected = record.children.some((child) => child.isSelected);
        }
        if (record.isSelected && !record.includeChildren) {
          record.includeChildren = record.children.some((child) => child.includeChildren);
        }
        if (record.isSelected && !record.lookupRelationship) {
          record.lookupRelationship = record.children.some((child) => child.lookupRelationship);
        }
      });
      if ($scope.isSomeChildRecordsIncluded()) {
        $scope.parent.includeChildren = true;
      }
      if ($scope.isSomeLookupSelected()) {
        $scope.parent.lookupRelationship = true;
      }
    }
  });

  $scope.uncheckChildrenRecords = function (children) {
    if (angular.isArray(children) && children.length) {
      children.forEach((child) => {
        child.isSelected = false;
        $scope.uncheckChildrenRecords(child.children);
      });
    }
  };

  $scope.uncheckIncludeChildren = function (children) {
    if (angular.isArray(children) && children.length) {
      children.forEach((child) => {
        child.includeChildren = false;
        $scope.uncheckIncludeChildren(child.children);
      });
    }
  };

  $scope.uncheckLookupRelationship = function (children) {
    if (angular.isArray(children) && children.length) {
      children.forEach((child) => {
        child.lookupRelationship = false;
        $scope.uncheckLookupRelationship(child.children);
      });
    }
  };

  $scope.isSomeChildRecordSelected = function () {
    return $scope.bulkRestoreData.childRecords[$scope.parent.recordId].some((record) => record.isSelected);
  };

  $scope.includeChildren = function (record) {
    record.includeChildren = !record.includeChildren;
    if (record.includeChildren && !record.isSelected) {
      record.isSelected = true;
    }
    if (!record.includeChildren) {
      $scope.uncheckIncludeChildren(record.children);
    }
    $scope.toggleParentCheckbox();
  };

  $scope.isAllChildRecordsIncluded = function () {
    return $scope.records.every((record) => record.isSelected && record.includeChildren);
  };

  $scope.isSomeChildRecordsIncluded = function () {
    return $scope.records.some((record) => record.isSelected && record.includeChildren);
  };

  $scope.selectAllChildren = function () {
    const isAllChildrenIncluded = !$scope.isAllChildRecordsIncluded();
    $scope.records.forEach((record) => {
      record.includeChildren = isAllChildrenIncluded;
      if (record.includeChildren && !record.isSelected) {
        record.isSelected = true;
      }
      if (!record.includeChildren) {
        $scope.uncheckIncludeChildren(record.children);
      }
    });
    $scope.toggleParentCheckbox();
  };

  $scope.noChildRecords = function () {
    return $scope.records.every((record) => !record.children.length);
  };

  $scope.toggleGroupLookup = function (key) {
    const isGroupLookupSelected = $scope.isGroupLookupSelected(key);
    $scope.records.forEach((record) => {
      if (record.sobjectName === key) {
        record.lookupRelationship = !isGroupLookupSelected;
        if (record.lookupRelationship && !record.isSelected) {
          record.isSelected = true;
        }
        if (!record.lookupRelationship) {
          $scope.uncheckLookupRelationship(record.children);
        }
      }
    });
    $scope.toggleParentCheckbox();
  };

  $scope.isSomeLookupSelected = function () {
    return $scope.records.some((record) => record.isSelected && record.lookupRelationship);
  };

  $scope.isAllLookupSelected = function () {
    return $scope.records.every((record) => record.isSelected && record.lookupRelationship);
  };

  $scope.selectAllLookups = function () {
    const isAllLookupSelected = !$scope.isAllLookupSelected();
    $scope.records.forEach((record) => {
      record.lookupRelationship = isAllLookupSelected;
      if (record.lookupRelationship && !record.isSelected) {
        record.isSelected = true;
      }
      if (!record.lookupRelationship) {
        $scope.uncheckLookupRelationship(record.children);
      }
    });
    $scope.toggleParentCheckbox();
  };

  $scope.lookupRelationship = function (record) {
    record.lookupRelationship = !record.lookupRelationship;
    if (record.lookupRelationship && !record.isSelected) {
      record.isSelected = true;
    }
    if (!record.lookupRelationship) {
      $scope.uncheckLookupRelationship(record.children);
    }
    $scope.toggleParentCheckbox();
  };

  $scope.$watch('records', function () {
    if ($scope.records) {
      if ($scope.isChildRecords) {
        $scope.pagingInfo.totalItems = _.size($scope.records);
      } else {
        $scope.countRecordsGroupBySobjectName = $scope.getSizeGroupRecords();
        $scope.pagingInfo.totalItems = $scope.countRecordsGroupBySobjectName;
      }
      $scope.pagingInfo.totalPages = Math.ceil($scope.pagingInfo.totalItems / $scope.pagingInfo.itemsPerPage);
    }
  });

  $scope.switchData = function (tabName) {
    $scope.model.currentTab = tabName;
  };

  $scope.shouldShowPaging = function () {
    return $scope.pagingInfo.totalPages > 1;
  };

  $scope.paginate = function (value, index) {
    let begin, end;
    begin = ($scope.pagingInfo.currentPage - 1) * $scope.pagingInfo.itemsPerPage;
    end = begin + $scope.pagingInfo.itemsPerPage;
    return begin <= index && index < end;
  };

  $scope.getSizeGroupRecords = function () {
    $scope.model.sobjectNameList = $scope.groupRecordsBySobjectName();
    return _.size($scope.model.sobjectNameList);
  };

  $scope.groupRecordsBySobjectName = function () {
    $scope.recordsGroupBySobjectName = _.groupBy($scope.records, 'sobjectName');
    return Object.keys($scope.recordsGroupBySobjectName);
  };
}
